import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1444818e = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _0d2e9e64 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _58b88715 = () => interopDefault(import('../../../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _d08279f8 = () => interopDefault(import('../../../pages/confirmation.vue' /* webpackChunkName: "pages/confirmation" */))
const _20694b32 = () => interopDefault(import('../../../pages/customer-terms.vue' /* webpackChunkName: "pages/customer-terms" */))
const _6257ef9c = () => interopDefault(import('../../../pages/forgot.vue' /* webpackChunkName: "pages/forgot" */))
const _11d83879 = () => interopDefault(import('../../../pages/join.vue' /* webpackChunkName: "pages/join" */))
const _3a6fa2ac = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _145f053f = () => interopDefault(import('../../../pages/modern-slavery.vue' /* webpackChunkName: "pages/modern-slavery" */))
const _805eb5f2 = () => interopDefault(import('../../../pages/organisation-sign-up.vue' /* webpackChunkName: "pages/organisation-sign-up" */))
const _067af9ca = () => interopDefault(import('../../../pages/payment/index.vue' /* webpackChunkName: "pages/payment/index" */))
const _4ca5b64a = () => interopDefault(import('../../../pages/premium/index.vue' /* webpackChunkName: "pages/premium/index" */))
const _c322f1b4 = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _7003f9e7 = () => interopDefault(import('../../../pages/review.vue' /* webpackChunkName: "pages/review" */))
const _92a07f92 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _88b866a8 = () => interopDefault(import('../../../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _c881bdb6 = () => interopDefault(import('../../../pages/store/index.vue' /* webpackChunkName: "pages/store/index" */))
const _131807f8 = () => interopDefault(import('../../../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _2bc3e3d4 = () => interopDefault(import('../../../pages/website-terms.vue' /* webpackChunkName: "pages/website-terms" */))
const _9070ee3e = () => interopDefault(import('../../../pages/account/details.vue' /* webpackChunkName: "pages/account/details" */))
const _58ef0916 = () => interopDefault(import('../../../pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _57cd5276 = () => interopDefault(import('../../../pages/account/premium.vue' /* webpackChunkName: "pages/account/premium" */))
const _56c43ce0 = () => interopDefault(import('../../../pages/premium/individual.vue' /* webpackChunkName: "pages/premium/individual" */))
const _b7e09dce = () => interopDefault(import('../../../pages/verify/new.vue' /* webpackChunkName: "pages/verify/new" */))
const _19208b93 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _419e329c = () => interopDefault(import('../../../pages/payment/_id.vue' /* webpackChunkName: "pages/payment/_id" */))
const _f31b116c = () => interopDefault(import('../../../pages/premium/_tier.vue' /* webpackChunkName: "pages/premium/_tier" */))
const _749093da = () => interopDefault(import('../../../pages/reset-password/_id.vue' /* webpackChunkName: "pages/reset-password/_id" */))
const _cbef0046 = () => interopDefault(import('../../../pages/store/_slug.vue' /* webpackChunkName: "pages/store/_slug" */))
const _df4c479a = () => interopDefault(import('../../../pages/verify/_id.vue' /* webpackChunkName: "pages/verify/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _1444818e,
    name: "404"
  }, {
    path: "/about",
    component: _0d2e9e64,
    name: "about"
  }, {
    path: "/checkout",
    component: _58b88715,
    name: "checkout"
  }, {
    path: "/confirmation",
    component: _d08279f8,
    name: "confirmation"
  }, {
    path: "/customer-terms",
    component: _20694b32,
    name: "customer-terms"
  }, {
    path: "/forgot",
    component: _6257ef9c,
    name: "forgot"
  }, {
    path: "/join",
    component: _11d83879,
    name: "join"
  }, {
    path: "/login",
    component: _3a6fa2ac,
    name: "login"
  }, {
    path: "/modern-slavery",
    component: _145f053f,
    name: "modern-slavery"
  }, {
    path: "/organisation-sign-up",
    component: _805eb5f2,
    name: "organisation-sign-up"
  }, {
    path: "/payment",
    component: _067af9ca,
    name: "payment"
  }, {
    path: "/premium",
    component: _4ca5b64a,
    name: "premium"
  }, {
    path: "/privacy-policy",
    component: _c322f1b4,
    name: "privacy-policy"
  }, {
    path: "/review",
    component: _7003f9e7,
    name: "review"
  }, {
    path: "/search",
    component: _92a07f92,
    name: "search"
  }, {
    path: "/sign-up",
    component: _88b866a8,
    name: "sign-up"
  }, {
    path: "/store",
    component: _c881bdb6,
    name: "store"
  }, {
    path: "/success",
    component: _131807f8,
    name: "success"
  }, {
    path: "/website-terms",
    component: _2bc3e3d4,
    name: "website-terms"
  }, {
    path: "/account/details",
    component: _9070ee3e,
    name: "account-details"
  }, {
    path: "/account/orders",
    component: _58ef0916,
    name: "account-orders"
  }, {
    path: "/account/premium",
    component: _57cd5276,
    name: "account-premium"
  }, {
    path: "/premium/individual",
    component: _56c43ce0,
    name: "premium-individual"
  }, {
    path: "/verify/new",
    component: _b7e09dce,
    name: "verify-new"
  }, {
    path: "/",
    component: _19208b93,
    name: "index"
  }, {
    path: "/payment/:id",
    component: _419e329c,
    name: "payment-id"
  }, {
    path: "/premium/:tier",
    component: _f31b116c,
    name: "premium-tier"
  }, {
    path: "/reset-password/:id?",
    component: _749093da,
    name: "reset-password-id"
  }, {
    path: "/store/:slug",
    component: _cbef0046,
    name: "store-slug"
  }, {
    path: "/verify/:id?",
    component: _df4c479a,
    name: "verify-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
